import React, { useContext, useEffect, useState } from 'react';
import { mediaHover, mediaNoHover, mediaShittyPointer } from '../../../../play-core/styles/Device';
import { isBrowser } from '../../../../play-core/utils/ssr-helper';
import { jsx as _jsx } from "react/jsx-runtime";
const initialState = {
  isMouseDevice: false,
  isTouchDevice: false
};
export const DeviceStateContext = /*#__PURE__*/React.createContext(initialState);
export const DeviceProvider = ({
  children
}) => {
  const [device, setDevice] = useState(initialState);
  useEffect(() => {
    if (isBrowser) {
      setDevice({
        isMouseDevice: window.matchMedia(mediaHover).matches,
        isTouchDevice: window.matchMedia(mediaNoHover).matches || window.matchMedia(mediaShittyPointer).matches
      });
    }
    const matchMouseHandler = value => setDevice(state => ({
      ...state,
      isMouseDevice: value.matches
    }));
    const matchTouchHandler = value => setDevice(state => ({
      ...state,
      isTouchDevice: value.matches
    }));

    // Safari 13 does not yet support addEventListener, so we keep using the old API for now.
    window.matchMedia(mediaHover).addListener(matchMouseHandler);
    [window.matchMedia(mediaNoHover), window.matchMedia(mediaShittyPointer)].forEach(media => media.removeListener(matchTouchHandler));
  }, []);
  return /*#__PURE__*/_jsx(DeviceStateContext.Provider, {
    value: device,
    children: children
  });
};
export const useDeviceState = () => {
  const context = useContext(DeviceStateContext);
  if (context === undefined) {
    throw new Error('useDeviceState must be used within a DeviceProvider');
  }
  return context;
};